import { useTheme } from 'styled-components';
import { Icon, CenteredPanel } from '@kinesis/bungle';

const Loading = (props: Props) => {
  const { magnitude = 'large' } = props;
  const theme = useTheme() as any;
  return (
    <CenteredPanel centerY>
      <Icon
        animation='rotate'
        color={theme.color.blue6}
        magnitude={magnitude}
        type='spinner'
      />
    </CenteredPanel>
  );
};

type Props = {
  magnitude?: string;
};

export { Loading };
